import React from 'react';
import ReactDOM from 'react-dom/client';
import { initializeSentry } from './utils/sentry.js';
import App from './App.jsx';
import './index.css';
import 'material-symbols';

// Initialize Sentry before rendering React
initializeSentry();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
